<!--
 * @Autor: zhiying Qin
 * @Date: 2025-04-09 23:32:47
 * @LastEditTime: 2025-09-27 18:08:03
-->
<template>
    <div class="listPost">
    <van-action-sheet v-model="show">
      <div class="content-action">
        <div style="display: flex; justify-content: space-between; align-items: center;" class="action-top">
            <div class="left">
                <h2>是否搜索匹配"不限专业"岗位信息</h2>
                <p>不限专业的岗位所有专业均可报名网申</p>
            </div>
            <div class="right">
                <van-switch v-model="checkedSwitch" @input="onInput" size="24px"  active-color="rgb(20,65,134)"/>
            </div>
        </div>


        <div style="display: flex;align-items: center;">
            <van-field v-model="major"  placeholder="请输入专业" style="width:80%" right-icon="warning-o" @click-right-icon="majorFunc"/>
            <van-button style="border-radius: 4px;margin-left: 8px;background-color: rgb(20,65,134);border: none;"
              @click="addTextMajor" type="info" >添加</van-button>
        </div>
        <div style="color: red;font-size: 12px;width: 100%;text-align: right;">
          输入专业后请点击添加即可筛选
        </div>
        <div v-if="majorList.length" style="margin-bottom: 10px;">
            <van-tag closeable size="medium" type="primary" style="margin-right: 10px;background-color: rgb(20,65,134)"
              v-for="(item, index) in majorList" :key="index" @close="close2(index)">{{
                item
              }}</van-tag>
          </div>
        <div class="item">
          <p>学历</p>
          <ul>
            <li v-for="(item, index) in educationNewList" :key="index"
              @click="handle('background', item, index, 'educationNewListIndex')"
              :class="educationNewListIndex == index ? 'active' : ''">
              {{ item.text }}
            </li>
          </ul>
        </div>
 <div class="item">
          <p>企业类型</p>
          <ul>
            <li v-for="(item, index) in companyType" :key="index"
              @click="handle2('companyType', item, index, 'educationNewListIndex2')"
              :class="educationNewListIndex2 == index ? 'active' : ''">
              {{ item.text }}
            </li>
          </ul>
        </div>
        <div style="display: flex;align-items: center;">
            <van-field v-model="city"  placeholder="请输入地址" style="width:80%" right-icon="warning-o" @click-right-icon="cityFunc"/>
            <van-button style="border-radius: 4px;margin-left: 8px;background-color: rgb(20,65,134);border: none;"
              @click="addTextCity" type="info" >添加</van-button>
        </div>
           <div style="color: red;font-size: 12px;width: 100%;text-align: right;">
          输入地址后请点击添加即可筛选
        </div>
        <div v-if="cityList.length" style="margin-bottom: 10px;">
            <van-tag closeable size="medium" type="primary" style="margin-right: 10px;background-color: rgb(20,65,134)"
              v-for="(item, index) in cityList" :key="index" @close="close1(index)">{{
                item
              }}</van-tag>
          </div>
        <!-- <van-field v-model="form.companyName"  placeholder="请输入企业类型" /> -->

        <van-field v-model="form.companyOrPostName"  placeholder="根据公司或岗位名称搜索" />


        <div style="display:flex; justify-content: space-between;margin-top: 20px;">
            <van-button type="default" round  @click="reset" style="width: 45%">重置</van-button>
            <van-button type="info" round  @click="confirmSubmit" style="width: 45%;background-color: rgb(20,65,134);border: none;">确定</van-button>
        </div>
        <div style="width: 100%;font-size: 13px;color: #999;width: 100%;text-align: center;margin-top: 20px;">查询岗位为往期参考的岗位，以实际招聘岗位为准。</div>
      </div>
    </van-action-sheet>


    <div class="right-icon-block" @click="show = true">
        <van-icon name="bars" size="24"/>
    </div>

    <div class="right-icon-block" style="top: 80vh;" @click="backTop">
        <van-icon name="arrow-up" size="24"/>
    </div>


    <!-- <div style="background: #EBF8FE; width: 100vw;padding: 10px 10px;" >
        <van-field
            v-model="form.companyName"
            right-icon="search"
            placeholder="根据公司名称搜索"
            @click-right-icon="onRefresh"
        />
    </div> -->
   
    


      <div class="ui-content" style="margin-top: 16px">
        <section class="record-list">
          <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
            <van-list
              v-model="loading"
              :finished="finished"
              :immediate-check="false"
              finished-text="没有更多了"
              @load="onLoad"
              offset="30"
              error-text="请求失败，点击重新加载"
            >
              <li v-for="item in list" :key="item.index" class="li-items">
                <p
                  :style="{fontSize: '16px', position: 'relative', padding: '0px 10px', fontWeight: item.isKeyCompany ? 'bold' : ''}"
                >
                  {{ item.companyName }}
                </p>
                <div style="margin: 10px">
                  <div class="title">
                    {{ item.workPost }}
  
                    <div :class="item.companyType!=6?'ribbon':'ribbon2'" v-if="item.companyType != null">
                      <div class="ribbon-text">{{ item.companyTypeDesc }}</div>
                    </div>
                  </div>
                  <div class="items-content">
                    <p class="tag">
                      <van-tag type="primary" style="margin-right: 10px">{{
                        item.postTypeDesc
                      }}</van-tag>
                      <van-tag type="primary" style="margin-right: 10px">{{
                        item.backgroundDesc
                      }}</van-tag>
                      <!-- <van-tag type="primary" style="margin-right: 10px">{{
                        item.graduationYear
                      }}</van-tag> -->
                    </p>
  
                    <ol>
                      <li>
                        <span class="label">涉及专业：</span>
                        <span class="label-content" style="line-height: 20px;">{{ item.major }}</span></li>
                      <!-- <li>
                        <span class="label">起止时间：</span>
                        <span class="label-content"
                          >{{ item.applyStartDate }} -
                          {{ item.applyEndDate }}</span
                        >
                      </li> -->
                      <li>
                        <span class="label">所在城市：</span>
                        <span class="label-content">{{ item.city }}</span>
                      </li>
                      <li>
                        <span class="label">应试要求：</span>
                        <span class="label-content" style="line-height: 20px;">{{ item.postRequire }}</span>
                      </li>
                    </ol>
                  </div>
                  <!-- <div class="items-content-footer">
                    <van-icon
                      :name="item.isCollect ? 'star' : 'star-o'"
                      size="20"
                      :color="item.isCollect ? 'orange' : ''"
                      @click="postCollect(item)"
                    />
  
                    <van-button
                      type="info"
                      size="small"
                      round
                      @click="copyUrl(item.sendLink)"
                      >报考链接</van-button
                    >
                  </div> -->
                </div>
              </li>
  
              <!-- 加载状态提示 -->
              <template #loading>
                <div class="loading-text">加载中...</div>
              </template>
            </van-list>
          </van-pull-refresh>
        </section>
      </div>
    </div>
  </template>
  
  <script>
  import Vue from 'vue'
  import { postList, getPostFilter, postCollect, myCollectList, experiencePostList, getDictType } from '@/api/xicaiquan'
  import { Tag, List, PullRefresh, Button, Toast } from 'vant'
  import { ActionSheet, Field,Switch, Dialog } from "vant";
  Vue.use(ActionSheet);
  Vue.use(Field);
  Vue.use(Tag)
  Vue.use(List)
  Vue.use(PullRefresh)
  Vue.use(Button)
  Vue.use(Switch)
  Vue.use(Toast)

  Vue.use(Dialog)
  export default {
    name: 'listPost',
    props: {
      type: String,
    //   form: Object,
      code: String
    },
    data () {
      return {
        showPopover: false,
        list: [1, 2, 3], // 列表数据
        loading: false, // 列表加载状态
        finished: false, // 列表是否加载完成
        isLoading: false, // 下拉刷新状态
        page: 1, // 当前页码
        pageSize: 10, // 每页条数
        queryParams: {
          current: 1,
          size: 10
        },
        show: true,
        checkedSwitch: true,
        form: {
            major: ["不限"],
            background: [],
            companyOrPostName: "",
            // graduationYear: [],
            companyType: [],
            // postType: [],
            // postType1Index: [],
            city: [],
            postStatus: ""
        },
        // graduationYear: [], // 毕业届
        companyType: [], // 企业类型
        postType: [], // 岗位类型
        postStatus: [], // 岗位状态
        educationNewList: [], // 学历
        
        byjIndex: 0,
        educationNewListIndex: -1,
        educationNewListIndex2: -1,

        // graduationYearIndex: 0,
        companyTypeIndex: 0,
        postTypeIndex: 0,
        postStatusIndex: 1,
        majorList: [],
        cityList: [],
        major: '',
        city: '',
        background: []
      }
    },
    created () {
      // if (this.type == "precisePost") {
      //   this.getPostFilter();
      // }
      // this.list = [];
        document.documentElement.scrollTop=0
        window.pageYOffset=0
        document.body.scrollTop=0
  

        this.queryParams.code = this.code;

    
        this.getDictType("company_type", "companyType", (data) => this.form.companyType = [])
        // this.getDictType("graduation_year", "graduationYear", (data) => this.form.graduationYear.push(data[0].value))
        // this.getDictType("post_type", "postType", (data) => this.form.postType.push(data[0].value))
        this.getDictType("education_new", "educationNewList", (data) => this.form.background = [])
        // this.getDictType("post_status", "postStatus", (data) => this.form.postStatus = data[1].value)

        this.loadData(1)
    },
    components: {},
    watch: {},  
    methods: {
      async getData (num) {
  
        //   if (!this.queryParams.graduationYear[0]) return
        //   if (!this.queryParams.postType[0]) return
        //   if (!this.queryParams.graduationYear[0]) return
  
          const res1 = await experiencePostList({...this.queryParams, ...this.form})
          if (res1.code == 200) {
            if(num!='1'){
            Toast({ message:`累计匹配岗位${res1.data.total}条`, position: 'bottom', className: 'custom-toast', });

            }
            console.log(res1,'=======')
            return (res1.data && res1.data.records) || []
          } else if (res1.code == 444) {
            Toast(res1.msg)
            this.$router.replace({path: '/empty'})
            
          }

          console.log("res1", res1)
          // console.log(res1);
      },
  
      // 加载数据
      async loadData (num) {
        try {
          const data = await this.getData(num)
          console.log('data111', data)
  
          if (data) {
             // 如果是第一页，直接替换数据
            if (this.queryParams.current === 1) {
              this.list = data
            } else {
              // 否则追加数据
              this.list = [...this.list, ...data]
            }
  
            // 判断是否还有更多数据
            if (data.length < this.queryParams.size) {
              this.finished = true
            }
          }
         
        } catch (error) {
          console.error('加载数据失败:', error)
        } finally {
          this.loading = false
          this.isLoading = false
        }
      },
      async getDictType(type, target, callback) {
        const res = await getDictType(type);
        if (res.code == 200) {
            res.data.forEach(item => {
            if (type == 'company_type') {
                this['companyType'].push({
                text: item.dictLabel,
                value: item.dictLabel,
                });
            }else{
                this[target].push({
                text: item.dictLabel,
                value: item.dictValue,
            });
            }
            
            })
            callback && callback(this[target]);
        }
        console.log(this.companyType,'companyTypecompanyTypecompanyType')
     },
  
      // 列表滚动到底部时触发
      onLoad () {
        if (this.finished) return
  
        console.log("执行的。。。。。")
        this.queryParams.current++
        this.loadData(1)
      },
  
      // 下拉刷新触发
      onRefresh () {
        this.queryParams.current = 1
        this.finished = false
        this.loading = true
        this.loadData()
      },
      addTextMajor() {
        if (!this.major) return;
        this.majorList.push(this.major);
        this.major = "";

        // this.show = false;
        // this.loadData()
      },
      addTextCity() {
        if (!this.city) return;
        this.cityList.push(this.city);
        this.city = "";

        // this.show = false;
        // this.loadData()
      },
      majorFunc(){
        Dialog.alert({
            title: '提示',
            messageAlign:'left',
            message: '填写专业说明：\n填入专业相关的关键词即可，并且可填写多个，越全面匹配的岗位越多\n例如：机械设计及其自动化专业\n输入：机械   自动化   制造    设备   变成  机电',
        }).then(() => {
            // on close
        });
      },
      cityFunc() {
        Dialog.alert({
            title: '提示',
            messageAlign:'left',

            message: '填写报考地区说明：\n填入地区的关键词即可，并且可填写多个，越全面匹配的岗位越多，不填写则不限制地区。\n例如：江苏 南通 北京 上海 深圳 广东',
        }).then(() => {
            // on close
        });
      },
      // 收藏
      async postCollect (item) {
        const res = await postCollect({ id: item.id, isCollect: !item.isCollect })
        if (res.code == 200) {
          if (item.isCollect) {
            Toast('已取消收藏')
          } else {
            Toast('收藏成功')
          }
        }
  
        item.isCollect = !item.isCollect
      },
      close1(indexToRemove) {
        this.cityList.splice(indexToRemove, 1)
      },
      close2(indexToRemove) {
        this.majorList.splice(indexToRemove, 1)
      },
    //   handle(type, item, index, typeIndex) {
    //     if (!this[typeIndex].includes(index)) {
    //         this.background.push(item.value)
    //         // this.form[type].push(item.value)
    //         this[typeIndex].push(index);
    //     } else {
    //         let findIndex = this[typeIndex].findIndex(item => item == index)

    //         this[typeIndex].splice(findIndex, 1)
    //         this.background.splice(findIndex, 1)
    //     }
        
    //   },
       handle(type, item, index, typeIndex) {
            this.form.background = [item.value]
            // this.form[type].push(item.value)
            this[typeIndex] = index;
      },
        handle2(type, item, index, typeIndex) {
            this.form.companyType = [item.value]
            // this.form[type].push(item.value)
            this[typeIndex] = index;
      },
      
      confirmSubmit() {
        this.form.major = [...this.form.major, ...this.majorList];
        this.form.city = [...this.cityList];
        // this.form.background = this.background.join(' ')
        this.show = false
        this.onRefresh()
      },
      reset() {
        this.form = {
            major: ["不限"],
            background: [],
            companyName: "",
            graduationYear: [],
            companyType: [],
            city: [],
        }

        this.background = []
        this.educationNewListIndex = -1

        this.majorList = []
        this.cityList = []

        this.checkedSwitch = true;

        this.show = false

        // if (!this.form.major.includes('不限')) {
        //         this.form.major.push('不限')
        // }

        this.onRefresh()
      },
      copyUrl (url) {
        // 创建一个临时的文本输入框
        const tempInput = document.createElement('input')
        // 将需要复制的内容赋值给输入框
        tempInput.value = url
        // 将输入框添加到文档中
        document.body.appendChild(tempInput)
        // 选中输入框的内容
        tempInput.select()
        // 执行复制命令
        document.execCommand('copy')
        // 从文档中移除临时输入框
        document.body.removeChild(tempInput)
  
        Toast('复制成功')
      },
      onInput(checked) {
        console.log(checked)

        if (checked) {
            if (!this.form.major.includes('不限')) {
                this.form.major.push('不限')
            }
        } else {
            let index = this.form.major.findIndex(item => item == '不限')
            this.form.major.splice(index, 1)
        }
      },
      backTop() {
        document.documentElement.scrollTop = 0
        window.pageYOffset = 0
        document.body.scrollTop = 0 
      },
    }
  }
  </script>
  <style scoped lang="scss">
 
  ::v-deep .custom-toast {
  background-color: red !important;
  color: #fff !important;
}
::v-deep .van-toast {
  background-color: red !important;
  color: #fff !important;
}
::v-deep .van-dialog__message{
  text-align: left !important;
}
.active {
  background: #eaf4ff;
  color: #5ca3fe;
  font-weight: bold;
}

.action-top {
    margin-bottom: 20px;
    .left {
        h2 {
            font-size: 18px;
        }

        p {
            color: #999;
            font-size: 14px;
            margin-top: 4px;
        }
    }

    .right {
        /deep/ .van-switch__node {
            width: 24px;
            height: 24px;
        }

        /deep/ .van-switch--on {
            .van-switch__node {
                right: 14px;
                left: inherit;
            }
        }
    }
}

.right-icon-block {
    position: fixed;
    right: 10px; 
    top: 10vh; 
    width: 30px; 
    height: 30px; 
    border-radius: 50%; 
    display: flex; 
    align-items: center; 
    justify-content: center;
    box-shadow: 0px 0px 3px 4px #ddd;
    background: #fff;
    z-index: 1111;
}

  .listPost {
    width: 100%;
    .ui-content {
      width: 95%;
      margin: 0px auto;
      .li-items {
        border-radius: 10px;
        background: #fff;
        margin-bottom: 20px;
        p {
          border-bottom: 1px solid #ddd;
          line-height: 40px;
          padding: 10px;
        }
  
        .title {
          background: #e0edfe;
          border-radius: 10px 10px 0px 0px;
          line-height: 40px;
          font-size: 16px;
          text-indent: 20px;
          margin-top: 20px;
          position: relative;
          overflow: hidden;
          padding-right: 10px;
          text-overflow: ellipsis;
          white-space: nowrap;
  
          .ribbon {
            width: 80px;
            height: 40px;
            background: orange;
            position: absolute;
            top: 0;
            right: -25px;
            transform: rotate(34deg);
            transform-origin: top right;
            box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
          }
   .ribbon2 {
            width: 80px;
            height: 40px;
            background: orange;
            position: absolute;
            top: 12px;
            right: -25px;
            transform: rotate(34deg);
            transform-origin: top right;
            box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
          }
          .ribbon-text {
            position: absolute;
            top: 12px;
            right: 12px;
            color: white;
            font-weight: bold;
            font-size: 12px;
            transform: rotate(0deg);
            transform-origin: right center;
            font-family: 'Arial', sans-serif;
          }
  
          /* 可选：让角标右上角带圆角 */
          .ribbon::before {
            content: '';
            position: absolute;
            top: 0;
            right: 0;
            width: 12px;
            height: 12px;
            background: white;
            border-top-left-radius: 12px;
          }
        }
  
        .items-content {
          background: #fafbff;
          padding: 20px;
          .tag {
            display: flex;
          }
  
          ol {
            margin: 20px 0px;
            li {
              display: flex;
              margin: 20px 0px;
              .label {
                color: #999;
                white-space: nowrap;
              }
              .label-content {
              }
            }
          }
        }
  
        .items-content-footer {
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-top: 1px solid #ddd;
          padding: 14px 10px;
          background: #fafbff;
        }
      }
    }
  }


.content-action {
  padding: 30px 20px;

  /deep/ .van-cell {
    margin: 6px 0px;
    border: 1px solid #ddd;
    border-radius: 10px;
  }

  .item {
    margin: 14px 0px;

    p {
      font-size: 15px;
      margin: 10px;
    }

    ul {
      display: flex;
      flex-wrap: wrap;

      li {
        margin: 0px 4px;
        width: 78px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        font-size: 14px;
        background: #f5f8fa;
        margin-bottom: 10px;
      }
    }
  }
}
  </style>
  